import { FC } from 'react';
import CloseIcon from '../../assets/icons/close.svg?react';
import styles from './Modal.module.css';

export interface CloseButtonProps {
  onClick?: () => void;
}

export const CloseButton: FC<CloseButtonProps> = ({ onClick }) => (
  <CloseIcon
    className={styles.close}
    onClick={onClick}
    data-testid="close-modal"
  />
);
